import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

registerLocaleData(localeIt, 'it-IT');

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
